import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import '@wdpr/checkbox';

@Component({
    selector: 'finder-ra-checkbox',
    templateUrl: './ra-checkbox.component.html',
    styleUrl: './ra-checkbox.component.scss',
    encapsulation: ViewEncapsulation.None,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    standalone: true,
})
export class RaCheckboxComponent implements AfterViewInit {
    @Input() checked;
    @Input() disabled;
    @Input() id;
    @Output() checkedChanged = new EventEmitter<any>();
    @Output() keydownEvent = new EventEmitter<any>();
    @Output() clickEvent = new EventEmitter<any>();
    @Output() reference = new EventEmitter<any>();

    @ViewChild('wdprCheckbox', { read: ElementRef }) raComponent: ElementRef;

    ngAfterViewInit(): void {
        // Emit a reference to this component instead of using ViewChild
        this.reference.emit(this);
    }

    onCheckChanged($event) {
        this.checkedChanged.emit($event);
    }

    onKeyDown($event) {
        this.keydownEvent.emit($event);
    }

    onClick($event) {
        this.clickEvent.emit($event);
    }
}
